import { getKey,insertKey,selectTerminalAll } from "../../api/config/modules/KeyFile";

const state = {
    getKey: {},
    insertKey: {},
    selectTerminalAll: {}
};

const mutations = {
    SET_GETKEY: (state, getKey) => {
        state.getKey = getKey;
    },
    SET_INSERTKEY: (state, insertKey) => {
        state.insertKey = insertKey;
    },
    SET_SELECTTERMINALALL: (state, selectTerminalAll) => {
        state.selectTerminalAll = selectTerminalAll;
    }
};

const actions = {
    GET_GETKEY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getKey(data)
                .then((res) => {
                    commit("SET_GETKEY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTKEY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertKey(data)
                .then((res) => {
                    commit("SET_INSERTKEY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTTERMINALALL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectTerminalAll(data)
                .then((res) => {
                    commit("SET_SELECTTERMINALALL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
